import { render, staticRenderFns } from "./VipPurchasePopup.vue?vue&type=template&id=27bad07e&scoped=true"
import script from "./VipPurchasePopup.vue?vue&type=script&lang=js"
export * from "./VipPurchasePopup.vue?vue&type=script&lang=js"
import style0 from "./VipPurchasePopup.vue?vue&type=style&index=0&id=27bad07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bad07e",
  null
  
)

export default component.exports